import http from '../helpers/http';

const PolicyViolations = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async () => {
      const result = await http.get(`/policy-violations`, {
        headers,
      });
      return result.data;
    },
    create: async (body: { name: string }) => {
      const result = await http.post(`/policy-violations`, body, { headers });
      return result.data;
    },
    delete: async (id: string) => {
      const result = await http.delete(`/policy-violations/${id}`, {
        headers,
      });
      return result.data;
    },
    file: async (policyViolationId: string, body: FormData) => {
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': token,
        },
      };
      const result = await http.patch(`/policy-violations/${policyViolationId}/file`, body, headers);
      return result.data;
    },
  };
};

export default PolicyViolations;
